import { render, staticRenderFns } from "./SysBtn.vue?vue&type=template&id=f497a68a&scoped=true"
import script from "./SysBtn.vue?vue&type=script&lang=js"
export * from "./SysBtn.vue?vue&type=script&lang=js"
import style0 from "./SysBtn.vue?vue&type=style&index=0&id=f497a68a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f497a68a",
  null
  
)

export default component.exports